import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ClientProgramsMap,
  ClientProgramsState,
  FetchClientProgramsPayload,
  SelectedClientProgramType,
} from '../types/dashboardConfig.types'

const initialState: ClientProgramsState = {
  selectedClientPrograms: null,
  allClientPrograms: null,
  caseEntityId : null,
}

const clientProgramSlice = createSlice({
  name: 'clientPrograms',
  initialState,
  reducers: {
    updateAllClientPrograms: (
      state: ClientProgramsState,
      action: PayloadAction<ClientProgramsMap>
    ) => {
      state.allClientPrograms = action.payload
    },
    updateSelectedClientProgram: (
      state: ClientProgramsState,
      action: PayloadAction<SelectedClientProgramType>
    ) => {
      state.selectedClientPrograms = action.payload
    },
    fetchAllClientPrograms: (
      state: ClientProgramsState,
      _action: PayloadAction<FetchClientProgramsPayload>
    ) => {
      return state
    },
    selectedCaseEntityReducer: (state: ClientProgramsState, action : PayloadAction<number>) =>
    {
      state.caseEntityId = action.payload;
    },
  },
})

export const {
  updateAllClientPrograms,
  updateSelectedClientProgram,
  fetchAllClientPrograms,
  selectedCaseEntityReducer,
} = clientProgramSlice.actions

export default clientProgramSlice.reducer
